
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/kaleido_hp",
      function () {
        return require("private-next-pages/kaleido_hp/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/kaleido_hp"])
      });
    }
  